<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.1076 2.25H15.8496C15.4356 2.25 15.0996 2.586 15.0996 3C15.0996 3.414 15.4356 3.75 15.8496 3.75H17.1076C18.8396 3.75 20.2506 5.16 20.2506 6.892V8.469C20.2506 8.883 20.5866 9.219 21.0006 9.219C21.4146 9.219 21.7506 8.883 21.7506 8.469V6.892C21.7506 4.333 19.6676 2.25 17.1076 2.25Z"
        fill="#FAFAFA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 9.219C3.414 9.219 3.75 8.883 3.75 8.469V6.892C3.75 5.16 5.16 3.75 6.893 3.75H8.182C8.596 3.75 8.932 3.414 8.932 3C8.932 2.586 8.596 2.25 8.182 2.25H6.893C4.333 2.25 2.25 4.333 2.25 6.892V8.469C2.25 8.883 2.586 9.219 3 9.219Z"
        fill="#FAFAFA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.15 20.2493H6.892C5.16 20.2493 3.75 18.8393 3.75 17.1073V15.5303C3.75 15.1163 3.414 14.7803 3 14.7803C2.586 14.7803 2.25 15.1163 2.25 15.5303V17.1073C2.25 19.6663 4.333 21.7493 6.892 21.7493H8.15C8.564 21.7493 8.9 21.4133 8.9 20.9993C8.9 20.5853 8.564 20.2493 8.15 20.2493Z"
        fill="#FAFAFA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.9994 14.7803C20.5854 14.7803 20.2494 15.1163 20.2494 15.5303V17.1073C20.2494 18.8393 18.8404 20.2493 17.1074 20.2493H15.8174C15.4034 20.2493 15.0674 20.5853 15.0674 20.9993C15.0674 21.4133 15.4034 21.7493 15.8174 21.7493H17.1074C19.6674 21.7493 21.7494 19.6663 21.7494 17.1073V15.5303C21.7494 15.1163 21.4134 14.7803 20.9994 14.7803Z"
        fill="#FAFAFA" />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.21826 7.64273V9.35473C6.21826 10.1397 6.85626 10.7777 7.64026 10.7777H9.35326C10.1373 10.7777 10.7763 10.1397 10.7763 9.35473V7.64273C10.7763 6.85773 10.1373 6.21973 9.35326 6.21973H7.64026C6.85626 6.21973 6.21826 6.85773 6.21826 7.64273Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.42426 13.1514H7.64026C6.85626 13.1514 6.21826 13.7904 6.21826 14.5754V16.3584C6.21826 17.1434 6.85626 17.7814 7.64026 17.7814H9.42426C10.2083 17.7814 10.8463 17.1434 10.8463 16.3584V14.5754C10.8463 13.7904 10.2083 13.1514 9.42426 13.1514Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5744 10.8506H16.3574C17.1414 10.8506 17.7804 10.2126 17.7804 9.42866V7.64466C17.7804 6.86066 17.1414 6.22266 16.3574 6.22266H14.5744C13.7904 6.22266 13.1514 6.86066 13.1514 7.64466V9.42866C13.1514 10.2126 13.7904 10.8506 14.5744 10.8506Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0068 16.0898C13.5928 16.0898 13.2568 16.4258 13.2568 16.8398C13.2568 17.2538 13.5928 17.5898 14.0068 17.5898H14.0708C14.4858 17.5898 14.7888 17.2538 14.7888 16.8398C14.7888 16.4258 14.4208 16.0898 14.0068 16.0898Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.3232 16.0898C16.9092 16.0898 16.5732 16.4258 16.5732 16.8398C16.5732 17.2538 16.9092 17.5898 17.3232 17.5898H17.3872C17.8022 17.5898 18.1052 17.2538 18.1052 16.8398C18.1052 16.4258 17.7372 16.0898 17.3232 16.0898Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.3232 12.7793C16.9092 12.7793 16.5732 13.1153 16.5732 13.5293C16.5732 13.9433 16.9092 14.2793 17.3232 14.2793H17.3872C17.8022 14.2793 18.1052 13.9433 18.1052 13.5293C18.1052 13.1153 17.7372 12.7793 17.3232 12.7793Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.665 15.9346H15.729C16.144 15.9346 16.447 15.5986 16.447 15.1846C16.447 14.7706 16.079 14.4346 15.665 14.4346C15.251 14.4346 14.915 14.7706 14.915 15.1846C14.915 15.5986 15.251 15.9346 15.665 15.9346Z"
      fill="#FAFAFA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0068 12.7793C13.5928 12.7793 13.2568 13.1153 13.2568 13.5293C13.2568 13.9433 13.5928 14.2793 14.0068 14.2793H14.0708C14.4858 14.2793 14.7888 13.9433 14.7888 13.5293C14.7888 13.1153 14.4208 12.7793 14.0068 12.7793Z"
      fill="#FAFAFA" />
  </svg>
</template>
